<div class="modal-header">
  <h1 class="modal-title">Contact Us</h1>
  <button (click)="closeModal()" aria-label="Close" class="btn-close" type="button"></button>
</div>

<div class="modal-body">
  @if (message()) {
    <div class="alert alert-dismissible" [ngClass]="{ 'alert-success': isSuccessMsg(), 'alert-danger': !isSuccessMsg() }" role="alert">
      <button type="button" class="btn-close" aria-label="Close" (click)="message.set(undefined)"></button>
      <div class="alert-message">{{ message() }}</div>
    </div>
  }

  <form style="min-height: 500px" [formGroup]="form()">
    <formly-form [hidden]="isCaptchaVisible()" [form]="form()" [fields]="formFields()" />
    @if (isCaptchaVisible()) {
      <app-captcha #captcha (isValidChange)="onCaptchaComplete($event)" />
      @if (captcha.isLoading()) {
        <div class="d-flex p-2" style="height: 100%; align-items: center; justify-content: center">
          <span class="spinner-border" style="--bs5-spinner-width: 4rem; --bs5-spinner-height: 4rem"></span>
        </div>
      }
    } @else {
      <p class="text-center mt-3 mb-3" data-cy="supportMessage">
        For pharmacy technical support, please text your NPI or call 833.613.2333
      </p>
      <p class="text-justify mb-3" style="font-size: 80%; word-break: break-all; text-align-last: center">
        By texting brightscrip at 833.613.2333, you agree to receive Conversations (external) messages from brightscrip. Reply STOP to
        opt-out; Reply HELP for support; Message & data rates may apply; Messaging frequency may vary. Visit
        <a href="https://brightscrip.com/privacy-policy" target="_blank">https://brightscrip.com/privacy-policy</a> to see our privacy
        policy and <a href="https://brightscrip.com/terms-of-use" target="_blank">https://brightscrip.com/terms-of-use</a> for our Terms of
        Service. For help, please email us at <a href="mailto:support@brightscrip.com">support&#64;brightscrip.com</a> or call us at
        <a href="tel:833.613.2333">833.613.2333</a>
      </p>
      <div class="text-center">
        <chitin-button label="Submit" (clicked)="submit()" [disabled]="form().invalid" [isLoading]="isSaving()" data-cy="submitBtn" />
      </div>
    }
  </form>
</div>
